export default __webpack_public_path__ + "static/media/two-stage.533d888a.png";